const duplicateOrder = (order_status, order_id, navigate, reformat_id = null) => {
  const link = reformat_id
    ? `/reformatting/?edit_order=true&duplicate=true&order=${order_id}&reformat_id=${reformat_id}`
    : `/addneworder/?order_status=${order_status}&order=${order_id}`;

  navigate(link);
};

export default duplicateOrder;
